import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, Phone, Linkedin, Facebook, Instagram, MessageCircle, MapPin } from 'lucide-react';
import { COMPANY_INFO } from '../../config/constants';

const LOGO_URL = '/cost-logo.png';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { name: 'Features', href: '/features' },
      // { name: 'Pricing', href: '/pricing' },
      { name: 'Solutions', href: '/solutions' },
      { name: 'AI Capabilities', href: '/ai-capabilities' },
    ],
    company: [
      { name: 'About', href: '/about' },
      // { name: 'Contact', href: '/demo' },
      { name: 'FAQ', href: '/faq' },
    ],
    legal: [
      { name: 'Privacy', href: '/privacy' },
      { name: 'Terms', href: '/terms' },
    ],
  };

  const socialLinks = [
    { name: 'LinkedIn', href: COMPANY_INFO.linkedin, icon: Linkedin },
    { name: 'Facebook', href: COMPANY_INFO.facebook, icon: Facebook },
    { name: 'WhatsApp', href: COMPANY_INFO.whatsapp, icon: MessageCircle },
  ];

  return (
    <footer className="relative border-t border-white/5" data-testid="footer">
      <div className="absolute inset-0 bg-gradient-to-t from-[#061425] to-transparent" />
      
      <div className="relative max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-4">
            <Link to="/" className="inline-block mb-6" data-testid="footer-logo">
              <img src={LOGO_URL} alt="Cost Genie" className="h-12 w-auto" />
            </Link>
            <p className="text-white/50 text-sm leading-relaxed mb-4 max-w-xs">
              {COMPANY_INFO.tagline}
            </p>
            <div className="flex items-start gap-2 mb-6 text-white/40 text-sm leading-relaxed max-w-xs">
             <p>Powered by: Excelleta Tech Pvt. Ltd.</p>
            </div>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 text-white/50 hover:text-[#00D4FF] hover:border-[#00D4FF]/30 transition-all"
                  data-testid={`footer-${social.name.toLowerCase()}`}
                  whileHover={{ scale: 1.1, y: -2 }}
                >
                  <social.icon className="w-4 h-4" />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-white font-semibold text-sm mb-4">Product</h4>
              <ul className="space-y-3">
                {footerLinks.product.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="text-white/40 text-sm hover:text-[#00D4FF] transition-colors">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h4 className="text-white font-semibold text-sm mb-4">Company</h4>
              <ul className="space-y-3">
                {footerLinks.company.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="text-white/40 text-sm hover:text-[#00D4FF] transition-colors">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-4">Legal</h4>
              <ul className="space-y-3">
                {footerLinks.legal.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="text-white/40 text-sm hover:text-[#00D4FF] transition-colors">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-4">Contact</h4>
              <ul className="space-y-3">
                <li>
                  <a href={`mailto:${COMPANY_INFO.email}`} className="text-white/40 text-sm hover:text-[#00D4FF] transition-colors flex items-center gap-2">
                    <Mail className="w-4 h-4" />
                    {COMPANY_INFO.email}
                  </a>
                </li>
                <li>
                  <a href={COMPANY_INFO.whatsapp} target="_blank" rel="noopener noreferrer" className="text-white/40 text-sm hover:text-[#00D4FF] transition-colors flex items-center gap-2">
                    <Phone className="w-4 h-4" />
                    {COMPANY_INFO.phone}
                  </a>
                </li>
                <li className="text-white/40 text-sm hover:text-[#00D4FF] transition-colors flex items-start gap-2">
                  <MapPin className="w-[100px] h-4" /> 5th Floor, Awfis, NH- 8, Ambience Island, DLF Phase 3, Sector 24, Gurugram, Haryana 122010
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-white/30 text-sm">
            &copy; {currentYear} Cost Genie. Powered by Excelleta.
          </div>
          
          {/* <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10">
            <div className="w-2 h-2 rounded-full bg-[#00D4FF] animate-pulse" />
            <span className="text-white/50 text-sm">CII DigiTech Recognized</span>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
